<script setup lang="ts">
import './assets/style.scss'
import { VContentGridItem } from '@/shared/ui'
import WCabinetMeterContent from './WCabinetMeterContent.vue'
import useModel from './../model/model'
import { computed, toRef, watch } from 'vue'
import WCabinetMeterHeader from './WCabinetMeterHeader.vue'
import { useRoute } from 'vue-router'
import { useSseConnection } from '@/shared/lib'

defineOptions({ name: 'meter' })

const props = defineProps({
  meterId: {
    type: Number,
    required: true,
  },
  objectId: {
    type: Number,
    required: false,
  },
})

const { meter, limits, contactorStatus, isMonitoring, isSummaryLimits, loadData } = useModel()
const route = useRoute()

const { refetch } = loadData(toRef(props, 'meterId'))

/* Устанавливаем SSE соединение */
const objectId = computed(() => Number(props.objectId || route.params.object_id))

const { handler } = useSseConnection(async (res: { meter_id: number }) => {
  if (res.meter_id && res.meter_id === props.meterId) await refetch()
})

watch(
  () => objectId,
  () => {
    handler(`/cabinets/${objectId.value}/statuses`)
  },
  { immediate: true },
)
</script>

<template>
  <VContentGridItem compact>
    <template #title>
      <WCabinetMeterHeader v-if="meter" :meter />
    </template>

    <WCabinetMeterContent
      v-if="meter"
      :meter
      :limits
      :contactorStatus
      :isMonitoring
      :isSummaryLimits
      :objectId
    />
  </VContentGridItem>
</template>
